import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { compose } from '../../../../node_module_clones/recompose';
import { connect } from 'react-redux';
import { flow } from 'lodash/fp';

import liveCollaborationStoreConnect from '../../../remoteActivity/liveCollaboration/store/liveCollaborationStoreConnect';

// Util
import { gridPointsToPixels } from '../../../utils/grid/gridUtils';
import { translateFreehandPoint } from '../drawingEditor/perfectFreehandUtils';

// Selectors
import { getLiveDrawings } from '../store/liveDrawingSelector';
import { getHasLiveCollaborators } from '../../../remoteActivity/liveCollaboration/liveCollaborationSelector';
import { getGridSize } from '../../../utils/grid/gridSizeSelector';

// Components
import DrawingEditorCanvasSvg from '../drawingEditor/drawingEditorCanvas/DrawingEditorCanvasSvg';
import DrawingPath from '../drawingEditor/drawingEditorCanvas/DrawingPath';

import './LiveDrawingCanvasRenderer.scss';

const convertGridUnitPointToPixels =
    (gridSize) =>
    ([x, y, pressure]) =>
        [gridPointsToPixels(x, gridSize), gridPointsToPixels(y, gridSize), pressure];

const mapStateToProps = createStructuredSelector({
    hasLiveCollaborators: getHasLiveCollaborators,
    gridSize: getGridSize,
});

const mapLiveCollaborationStateToProps = createStructuredSelector({
    liveDrawings: getLiveDrawings,
});

const LiveDrawingCanvasRenderer = ({ hasLiveCollaborators, translation = { x: 0, y: 0 }, liveDrawings, gridSize }) => {
    if (!hasLiveCollaborators) return null;

    const preparePoint = flow(convertGridUnitPointToPixels(gridSize), translateFreehandPoint(translation));

    const allPaths = liveDrawings
        .toArray()
        .flatMap(({ paths }) => paths)
        .map(({ points, ...rest }) => ({
            ...rest,
            points: points.map(preparePoint),
        }));

    return (
        <div className="LiveDrawingCanvasRenderer">
            <DrawingEditorCanvasSvg>
                {allPaths.map(({ id, ...rest }) => (
                    <DrawingPath key={id} {...rest} />
                ))}
            </DrawingEditorCanvasSvg>
        </div>
    );
};

LiveDrawingCanvasRenderer.propTypes = {
    hasLiveCollaborators: PropTypes.bool,
    translation: PropTypes.object,
    liveDrawings: PropTypes.object,
    gridSize: PropTypes.number,
};

const enhance = compose(connect(mapStateToProps), liveCollaborationStoreConnect(mapLiveCollaborationStateToProps));

export default enhance(LiveDrawingCanvasRenderer);
